import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Paragraph",
    type: "object",
    properties: {
      ...Utils.properties,
      // The same Quill delta a `paragraph` ELEMENT stores, and the same widget
      // authors it — see common/schema/page-element/types/paragraph. The two
      // are one feature seen from the two places content is written: on a page,
      // and in a slot a section declares.
      //
      // The stored value is converted to HTML by resolveValues, not here — a
      // template reads `<%-content%>` and gets markup, exactly as gen-2's did.
      default: {
        label: "Default value",
        type: "string",
        widget: "paragraph",
        default: `{"ops":[]}`,
      },
    },
    required: [],
  },
];
